import React, { useState } from 'react';
import { connect } from 'react-redux';
import { updateStepData } from '../../Store/Actions/Partner';

import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { Divider } from 'primereact/divider';
import { Panel } from 'primereact/panel';
import { Password } from 'primereact/password';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tooltip } from 'primereact/tooltip';

import Grid from '@mui/material/Grid';

import * as AppActions from '../../Store/Actions/App'
import ValidationCodeDialog from '../../Components/ValidationCodeDialog';


import {
	validarCNPJ,
	validarCPF,
	validarEmail,
	validarTelefone,
	validarNome,
	validarNomeEmpresa,
	maskCNPJ,
	maskCPF,
	maskPhone,
  validateSingleField
} from '../../Components/Utils';

const RegisterStep1 = (props) => {

  // Set var from props
  const { 
      stepIndex, 
      stepData, 
      stepDataAll,
      updateStepData,
      setAlert, 
      setAlertTitle, 
      setAlertBody,
      stepValidations,
      retrieveCompanyDocumentInfo,
      retrievePersonDocumentInfo,
      servicesList,
      specialitiesList,
      checkCompanyPersonUserEmail,
      checkCompanyPersonUserPhone,
      setGlobalInnerLoading,
      setGlobalInnerMessage      
  } = props;

  //console.log('<<<<<<<<<<<<<<servicesList STEP 1>>>>>>>>>>>>>>>>'+JSON.stringify(servicesList,null,2));
  //console.log('<<<<<<<<<<<<<<<specialitiesList STEP 1 >>>>>>>>>>>>>>>'+JSON.stringify(specialitiesList,null,2));

  //console.log('stepDataAll STEP 1----------->'+JSON.stringify(stepDataAll,null,2));

  // Set changed vars
  const formDataRef = React.useRef({});

  const [formFields, setFormFields] = React.useState({
    companyDocument: stepData?.companyDocument || '',
    companyDocumentSearched: stepData?.companyDocumentSearched || '',
    companyLegalName: stepData?.companyLegalName || '',
    companyFantasyName: stepData?.companyFantasyName || '',
    companyEmail: stepData?.companyEmail || '',
    companyPhone: stepData?.companyPhone || '',
    companyState: stepData?.companyState || '',
    companyCity: stepData?.companyCity || '',
    personCompanyName: stepData?.personCompanyName || '',
    personCompanyNameStatus: stepData?.personCompanyNameStatus ?? true,
    companyDocumentMeta: stepData?.companyDocumentMeta || '',
    companyPersonDocument: stepData?.companyPersonDocument || '',
    companyPersonName: stepData?.companyPersonName || '',
    companyPersonBirthDay: stepData?.companyPersonBirthDay || '',
    companyPersonGender: stepData?.companyPersonGender || '',
    companyPersonMothername: stepData?.companyPersonMothername || '',
    companyPersonDocumentMeta: stepData?.companyPersonDocumentMeta || '',
    personUserPhone: stepData?.personUserPhone || '',
    personUserEmail: stepData?.personUserEmail || '',
    personUserEmailConfirm: stepData?.personUserEmailConfirm || '',
    personUserPassword: stepData?.personUserPassword || '',
    personUserPasswordConfirm: stepData?.personUserPasswordConfirm || '',
    soloCompany: stepData?.soloCompany ?? false,
    acceptTerm: stepData?.acceptTerm ?? false,
    autoFields: stepData?.autoFields ?? true,
    autoFieldsPerson: stepData?.autoFieldsPerson ?? true,
    autoFieldsFill: stepData?.autoFieldsFill ?? true,
    autoFieldsFilled: stepData?.autoFieldsFilled ?? false,
    autoPersonFieldsFilled: stepData?.autoPersonFieldsFilled ?? false,
    documentReady: stepData?.documentReady ?? false,
    personDocumentReady: stepData?.personDocumentReady ?? false,
    validatedContact: stepData?.validatedContact ?? false, // controle se validou email e/ou telefone
    createdUser: stepData?.createdUser ?? false, // controle se criou o usuario

    emailInUse: stepData?.emailInUse ?? false,
    phoneInUse: stepData?.phoneInUse ?? false
  });  

  // Interface controls Loading Data
  const [loading, setLoading] = React.useState(true); 
  const [saving, setSaving] = React.useState(false); 
  const [loadingData, setLoadingData] = React.useState(false);
  const [loadingPersonData, setPersonLoadingData] = React.useState(false);

  const [showValidationDialog, setShowValidationDialog] = React.useState(false);
  
  /* Save on Redux Store changes on fielçds */
  const handleFieldChange = (fieldName, value) => {
    setFormFields(prev => {
      const updated = { ...prev, [fieldName]: value };
      formDataRef.current = updated;
      return updated;
    });
    formDataRef.current[fieldName] = value; // Atualiza o ref imediatamente também
  };

/* Save on Redux Store changes on actions */
  const setActionCompleted = (fieldName, status = true) => {
    updateStepData(stepIndex, { [fieldName]: status });
  };  


  /* Check if document is valid,. If yes, release button. If not, alert.*/
  const handleCompanyDocumentChange = (e) => {
    
    let inputValue = e.target.value;
    let maskedValue = maskCNPJ(inputValue);
  
    handleFieldChange('companyDocument', maskedValue);
  
    if (maskedValue.length === 18) { // CNPJ completo (99.999.999/9999-99)
      if (!validarCNPJ(maskedValue)) {
      //  setAlert(true);
      //  setAlertTitle("Verifique o CNPJ");
       // setAlertBody("O CNPJ informado é inválido. Verifique novamente.");
        handleFieldChange('documentReady', false);
        handleFieldChange('autoFields', true);
      } else {
        handleFieldChange('documentReady', true);
      }
    } else {
      // Se ainda não completou o CNPJ, desativa o botão
      handleFieldChange('documentReady', false);
      handleFieldChange('autoFields', true);
    }
  };
  

/* Check if document is valid,. If yes, release button. If not, alert.*/
const handlePersonDocumentChange = (e) => {

  let inputValue = e.target.value;
  let maskedValue = maskCPF(inputValue); 

  handleFieldChange('companyPersonDocument', maskedValue);

  if (maskedValue.length == 14) { // CPF completo (999.999.999-99)
    if (!validarCPF(maskedValue)) {
     // setAlert(true);
     // setAlertTitle("Verifique o CPF");
     // setAlertBody("O CPF informado é inválido. Verifique novamente.");
      handleFieldChange('personDocumentReady', false);
      handleFieldChange('autoFieldsPerson', true);
    } else {
      handleFieldChange('personDocumentReady', true);
    }
  } else {
    // Se ainda não completou o CNPJ, desativa o botão
    handleFieldChange('personDocumentReady', false);
    handleFieldChange('autoFieldsPerson', true);
  }  
	
}  // end function
  

  const handleBlur = () => {
    updateStepData(stepIndex, { ...formDataRef.current });
  };

  const handleRetrieveCompanyDocumentInfo = async () => {
    const rawCNPJ = formFields.companyDocument || '';
    const cleanCNPJ = rawCNPJ.replace(/\D/g, '');
  
    if (!validarCNPJ(cleanCNPJ)) {
      setAlertTitle('CNPJ inválido');
      setAlertBody('O CNPJ informado não é válido. Verifique e tente novamente.');
      setAlert(true);
      return;
    }
  
    setLoadingData(true);
  
    retrieveCompanyDocumentInfo(cleanCNPJ, {
      setSuccess: (response) => {
        setLoadingData(false);
  
        if (response.documentExists) {
          setAlertTitle('CNPJ já cadastrado');
          setAlertBody('Este CNPJ já está cadastrado. Se você já possui uma conta, utilize a opção de login.');
          setAlert(true);
          return;
        }
  
        const dados = response.data || {};

        // 🔎 Se não veio razão social e nem nome fantasia, desativa preenchimento automático
        if (!dados.razao) {
          handleFieldChange('autoFields', false);
          formDataRef.current.autoFields = false;
          updateStepData(stepIndex, { autoFields: false });
          setAlertTitle('Nenhum informação encontrada');
          setAlertBody('Nenhuma informação encontrada para o CNPJ informado. Informe os dados manualmente.');
          setAlert(true);
        } else {
          handleFieldChange('autoFields', true);
          formDataRef.current.autoFields = true;
          updateStepData(stepIndex, { autoFields: true });          
        }        
  
        const meta = {
          razao: dados.razao || '',
          fantasia: dados.fantasia || 'Não definido',
          situacao: dados.situacao?.nome || '',
          inicioAtividade: dados.inicioAtividade || '',
          cnae: {
            codigo: dados.cnae?.fiscal || '',
            descricao: dados.cnae?.descricao || ''
          },
          cnaes_secundarios: dados.cnae?.secundarias || [],
          porte: dados.porte?.descricao || '',
          naturezaJuridica: dados.naturezaJuridica?.descricao || '',
          simplesNacional: dados.simplesNacional || {},
          endereco: {
            logradouro: dados.matrizEndereco?.logradouro || '',
            numero: dados.matrizEndereco?.numero || '',
            complemento: dados.matrizEndereco?.complemento || '',
            bairro: dados.matrizEndereco?.bairro || '',
            cidade: dados.matrizEndereco?.cidade || '',
            uf: dados.matrizEndereco?.uf || '',
            cep: dados.matrizEndereco?.cep || ''
          },
          contato: {
            telefone: dados.telefones?.[0]?.ddd && dados.telefones?.[0]?.numero
              ? `(${dados.telefones[0].ddd}) ${dados.telefones[0].numero}`
              : '',
            email: dados.email || ''
          },
          socios: dados.socios || []
        };
  
        handleFieldChange('companyLegalName', dados.razao || '');
        handleFieldChange('companyFantasyName', dados.fantasia || 'Não definido');
        handleFieldChange('companyDocumentMeta', meta);
        handleFieldChange('companyDocumentSearched', 'ok');
  
        // Add fields
        handleFieldChange('companyEmail', dados.contato?.email || '');
        handleFieldChange('companyPhone', dados.contato?.telefone || '');
        handleFieldChange('companyState', dados.endereco?.uf || 'XX');
        handleFieldChange('companyCity', dados.endereco?.cidade || 'N/A');
        handleFieldChange('personCompanyName', dados.socios?.[0]?.nome || '');

        updateStepData(stepIndex, {
          companyLegalName: dados.razao || '',
          companyFantasyName: dados.fantasia || 'Não definido',
          companyDocumentMeta: meta,
          companyDocumentSearched: 'ok',
          companyEmail: dados.email || '',
          companyPhone: dados.telefones?.[0]?.numero || '',
          companyState: dados.matrizEndereco?.uf || 'XX',
          companyCity: dados.matrizEndereco?.cidade || 'N/A',
          personCompanyName: dados.socios?.[0]?.nome || '',
        });
      },
      setError: (message) => {
        setLoadingData(false);
        setAlertTitle('Erro');
        setAlertBody(message || 'Erro inesperado ao buscar dados do CNPJ.');
        setAlert(true);
      }
    });

  };

  const handleRetrievePersonDocumentInfo = () => {
    const rawCPF = formFields.companyPersonDocument || '';
    const cleanCPF = rawCPF.replace(/\D/g, '');
  
    if (!validarCPF(cleanCPF)) {
      setAlertTitle('CPF inválido');
      setAlertBody('O CPF informado não é válido. Verifique e tente novamente.');
      setAlert(true);
      return;
    }
  
    setPersonLoadingData(true)
  
    retrievePersonDocumentInfo(cleanCPF, {
      setSuccess: (response) => {
        setPersonLoadingData(false);
  
        if (response.documentExists) {
          setAlertTitle('CPF já cadastrado');
          setAlertBody('Este CPF já está vinculado a outro cadastro. Se já possui conta, faça login.');
          setAlert(true);
          return;
        }
  
        const dados = response.data || {};

        // 🔎 Se não veio razão social e nem nome fantasia, desativa preenchimento automático
        if (!dados.nome) {
          handleFieldChange('autoFieldsPerson', false);
          formDataRef.current.autoFieldsPerson = false;
          updateStepData(stepIndex, { autoFieldsPerson: false });
          setAlertTitle('Nenhum informação encontrada');
          setAlertBody('Nenhuma informação encontrada para o CPF informado. Informe os dados manualmente.');
          setAlert(true);
        } else {
          handleFieldChange('autoFieldsPerson', true);
          formDataRef.current.autoFieldsPerson = true;
          updateStepData(stepIndex, { autoFieldsPerson: true });
        }        
        
  
        const meta = {
          nome: dados.nome || '',
          nascimento: dados.nascimento || '',
          mae: dados.mae || '',
          genero: dados.genero || '',
          cpf: dados.cpf || '',
          status: dados.status || '',
          consultaID: dados.consultaID || '',
          delay: dados.delay || null
        };
  
        // Atualiza campos individuais e metas
        handleFieldChange('companyPersonName', dados.nome || '');
        handleFieldChange('companyPersonBirthDay', dados.nascimento || '');
        handleFieldChange('companyPersonGender', dados.genero || '');
        handleFieldChange('companyPersonMothername', dados.mae || '');
        handleFieldChange('companyPersonMeta', meta);
        handleFieldChange('companyPersonDocumentMeta', meta);
        handleFieldChange('companyPersonSearched', 'ok');
  
        updateStepData(stepIndex, {
          companyPersonName: dados.nome || '',
          companyPersonBirthDay: dados.nascimento || '',
          companyPersonGender: dados.genero || '',
          companyPersonMothername: dados.mae || '',
          companyPersonMeta: meta,
          companyPersonDocumentMeta: meta,
          companyPersonSearched: 'ok'
        });
      },
      setError: (message) => {
        setPersonLoadingData(false);
        setAlertTitle('Erro');
        setAlertBody(message || 'Erro inesperado ao buscar dados do CPF.');
        setAlert(true);
      }
    });
  };
  
  const handleCheckCompanyEmail = async () => {
      
    const email = formFields.personUserEmail?.trim();
    if (!email || !validarEmail(email)) return; // 🚫 se vazio ou inválido, não faz nada

    // global loading on
    setGlobalInnerLoading(true);
    setGlobalInnerMessage('Verificando e-mail...');

    checkCompanyPersonUserEmail(formFields.personUserEmail, {
      setSuccess: (resp) => {

        // global loading off
        setTimeout(() => { setGlobalInnerLoading(false); },1000);
        
        const used = resp.emailInUse;
        handleFieldChange('emailInUse', used);
        handleBlur();
      },
      setError: (msg) => {

        // global loading off
        setTimeout(() => { setGlobalInnerLoading(false); },1000);

        setAlertTitle('Erro ao verificar e-mail');
        setAlertBody(msg);
        setAlert(true);

      }
    });
  };

  const handleCheckCompanyPhone = async () => {

    const phone = formFields.personUserPhone?.trim();
    if (!phone || !validarTelefone(phone)) return; // 🚫 se vazio ou inválido, não faz nada

    // global loading on
    setGlobalInnerLoading(true);
    setGlobalInnerMessage('Verificando telefone...');

    checkCompanyPersonUserPhone(formFields.personUserPhone, {
        setSuccess: (resp) => {

        // global loading OFF
        setTimeout(() => { setGlobalInnerLoading(false); },1000);
        
        const used = resp.phoneInUse;
        handleFieldChange('phoneInUse', used);
        handleBlur();
        /*if (used) {
          setAlertTitle('Telefone em uso');
          setAlertBody('Este telefone já está sendo utilizado por outro parceiro. Por favor, escolha outro.');
          setAlert(true);
        }*/
      },
      setError: (msg) => {

        // global loading OFF
        setTimeout(() => { setGlobalInnerLoading(false); },1000);

        setAlertTitle('Erro ao verificar telefone');
        setAlertBody(msg);
        setAlert(true);
      }
    });
  };

	// Suggested password panel
  const PasswordTip = (
    <>
        <Divider />
        <p className="mt-1" style={{fontSize:"0.9rem"}}>Sugestão de senha</p>
        <ul className="pl-2 ml-2 mt-0 line-height-3" style={{fontSize:"0.8rem"}}>
            <li>Ao menos 1 letra maiúscula</li>
    <li>Ao menos 1 letra minúscula</li>
            <li>Ao menos 1 número </li>
    <li>Ao menos 1 símbolo ! # $ % & * + - = ? @ </li>
            <li>De 6 a 12 caracteres</li>
        </ul>
    </>
  );


  return (
    <div style={{ width: '100%'}}>

      <Panel header="Dados da empresa" style={{marginBottom:"20px",border:"0"}}>
        <Grid container spacing={4} style={{marginTop:"-20px"}}>
          <Grid item xs={12} sm={12} style={{display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"center"}}>
          <div className="w100 tAlignL formControl" style={{ position: 'relative'}}>
            <label htmlFor="companyDocument">CNPJ <span className="requiredField">*</span></label>
            <div style={{ display: 'flex', position: 'relative' }}>
              <InputText
                  id="companyDocument"
                  tabIndex={1}
                  autoComplete="off"
                  disabled={saving}
                  className="w100"
                  value={formFields.companyDocument}
                  onChange={(e) => handleCompanyDocumentChange(e)}
                  onBlur={() => {
                    handleBlur();
                    const error = validateSingleField(stepValidations, 'companyDocument', formFields.companyDocument);
                    if (error) {
                      setAlert(true);
                      setAlertTitle('CNPJ digitado é inválido');
                      setAlertBody(error);
                    }
                  }}
                  tooltip="Digite apenas números"
                  tooltipOptions={{ position: 'bottom', event: 'focus' }}
                  style={{ paddingRight: '6rem' }}
                  placeholder="Informe o CNPJ e aperte buscar"
                />
                <Button
                label={loadingData ? "Buscando" : "Buscar"}
                rounded
                disabled={!formFields.documentReady}
                className="pT10 headerButtonRight filled"
                style={{ position: 'absolute', right: '0.5rem', top: '50%', transform: 'translateY(-50%)', height: '2.2rem',maxWidth: '7.4rem'}}
                loading={loadingData}
                onClick={() => handleRetrieveCompanyDocumentInfo()}
              />
              </div>
              <small className="fLight">Digite um CNPJ válido e aperte buscar para trazer as informações automaticamente.</small>
          </div>            
          </Grid>

          <Grid item xs={12} sm={12}>
          <div className="w100 tAlignL formControl">
              <label htmlFor="companyLegalName">Razão Social <span className="requiredField">*</span></label>
              <InputText
                id="companyLegalName"
                autoComplete="new-password"
                disabled={saving || formFields.autoFields}
                className="w100"
                value={formFields.companyLegalName}
                onChange={(e) => handleFieldChange('companyLegalName', e.target.value)}
                onBlur={handleBlur}
                placeholder={formFields.autoFields ? "Digite o CNPJ e aperte buscar para preencher automaticamente" : "Informe a razão social da empresa"}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className="w100 tAlignL formControl">
            <label htmlFor="companyFantasyName">Nome Fantasia</label>
              <InputText
                id="companyFantasyName"
                autoComplete="new-password"
                disabled={saving || formFields.autoFields}
                className="w100"
                value={formFields.companyFantasyName}
                onChange={(e) => handleFieldChange('companyFantasyName', e.target.value)}
                onBlur={handleBlur}
                placeholder={formFields.autoFields ? "Digite o CNPJ e aperte buscar para preencher automaticamente" : "Informe o nome fantasia da empresa"}
              />
              
            </div>
          </Grid>

          <Grid item xs={12} sm={12} style={{display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"center"}}>
          <div className="w100 tAlignL formControl" style={{ position: 'relative'}}>
            <label htmlFor="personDocument">CPF do representante legal<span className="requiredField">*</span></label>
            <div style={{ display: 'flex', position: 'relative' }}>
              <InputText
                id="personDocument"
                tabIndex={2} 
                autoComplete="new-password"
                disabled={saving}
                value={formFields.companyPersonDocument}
                onChange={(e) => handlePersonDocumentChange(e)}
                onBlur={() => {
                  handleBlur();
                  const error = validateSingleField(stepValidations, 'companyPersonDocument', formFields.companyPersonDocument);
                  if (error) {
                    setAlert(true);
                    setAlertTitle('CPF digitado é inválido');
                    setAlertBody(error);
                  }
                }}             
                className="w100"
                tooltip="Digite apenas números"
                tooltipOptions={{ position: 'bottom', event: 'focus' }}
                style={{ paddingRight: '6rem' }}
                placeholder="Informe o CPF e aperte buscar"
              />
              <Button
                label={loadingPersonData ? "Buscando" : "Buscar"}
                disabled={!formFields.personDocumentReady}
                className="pT10 headerButtonRight filled"
                style={{ position: 'absolute', right: '0.5rem', top: '50%', transform: 'translateY(-50%)', height: '2.2rem',maxWidth: '7.4rem'}}
                size="small"
                loading={loadingPersonData}
                onClick={() => handleRetrievePersonDocumentInfo()}
              />
            </div>
          </div>
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className="w100 tAlignL formControl">
            <label htmlFor="personName">Nome do representante legal <span className="requiredField">*</span></label>
              <InputText
                id="personName"
                autoComplete="new-password"
                disabled={saving || formFields.autoFieldsPerson}
                value={formFields.companyPersonName}
                onChange={(e) => handleFieldChange('companyPersonName', e.target.value)}
                onBlur={handleBlur}
                style={{ width: "100%" }}
                placeholder={formFields.autoFieldsPerson ? "Digite o CPF e aperte buscar para preencher automaticamente" : "Informe o nome do representante legal da empresa"}          
              />
              
            </div>
          </Grid>
        </Grid>
      </Panel>        

      <Panel header="Dados de acesso (Principal conta administradora)">
        <Grid container spacing={4} style={{marginTop:"-20px"}}>
          <Grid item xs={12} sm={12}>
            <div className="w100 tAlignL formControl">
            <label htmlFor="email">E-mail (login) <span className="requiredField">*</span></label>
              <InputText
                id="email"
                tabIndex={3} 
                autoComplete="new-password"
                disabled={saving || formFields.validatedContact}
                value={formFields.personUserEmail}
                onChange={(e) => handleFieldChange('personUserEmail', e.target.value)}
                onBlur={() => {
                  handleBlur();
                  const error = validateSingleField(stepValidations, 'personUserEmail', formFields.personUserEmail);
                  if (error) {
                    setAlert(true);
                    setAlertTitle('Email digitado é inválido');
                    setAlertBody(error);
                  } else {
                    handleCheckCompanyEmail();
                  }
                }}
                style={{ width: "100%" }}
                placeholder="Informe o email do acesso principal da empresa."
              />
              {formFields.validatedContact && (
                <small className="fSuccess">E-mail validado. Para alterar, recarregue a página.</small>
              )}  
              {formFields.emailInUse && (
                <small className="fSuccess tColorRed">Este E-mail já está sendo utilizado por outro parceiro. Por favor, escolha outro. </small>
              )}                          
            </div>
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className="w100 tAlignL formControl">
            <label htmlFor="emailConfirm">Confirme o E-mail <span className="requiredField">*</span></label>
              <InputText
                id="emailConfirm"
                tabIndex={4} 
                autoComplete="new-password"
                disabled={saving || formFields.validatedContact}
                value={formFields.personUserEmailConfirm}
                onChange={(e) => handleFieldChange('personUserEmailConfirm', e.target.value)}
                onBlur={handleBlur}
                style={{ width: "100%" }}
                placeholder="Confirme o email do acesso principal da empresa."                
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className="w100 tAlignL formControl">
            <label htmlFor="companyPhone">Telefone celular <span className="requiredField">*</span></label>
              <InputText
                id="companyPhone"
                tabIndex={5} 
                autoComplete="new-password"
                disabled={saving || formFields.validatedContact}
                className="w100"
                value={formFields.personUserPhone}
                onChange={(e) => handleFieldChange('personUserPhone', maskPhone(e.target.value))}
                onBlur={() => {
                  handleBlur();
                  const error = validateSingleField(stepValidations, 'personUserPhone', formFields.personUserPhone);
                  if (error) {
                    setAlert(true);
                    setAlertTitle('Telefone digitado é inválido');
                    setAlertBody(error);
                  } else {
                    handleCheckCompanyPhone();
                  }
                }}               
                tooltip="Digite apenas números"
                tooltipOptions={{ position: 'bottom', event: 'focus' }}                
                placeholder="Informe o telefone celular do usuário"
              />
              {formFields.validatedContact && (
                <small className="fSuccess">Telefone validado. Para alterar, recarregue a página.</small>
              )}       
              {formFields.phoneInUse && (
                <small className="fSuccess tColorRed">Este telefone já está sendo utilizado por outro parceiro. Por favor, escolha outro. </small>
              )}                      
            </div>
          </Grid>          
          <Grid item xs={12} sm={12}>
            <div className="w100 tAlignL formControl">
            <label htmlFor="password">Senha <span className="requiredField">*</span></label>
              <Password
                inputId="password"
                tabIndex={6} 
                autoComplete="new-password"
                disabled={saving}
                toggleMask
                value={formFields.personUserPassword}
                onChange={(e) => handleFieldChange('personUserPassword', e.target.value)}
                onBlur={handleBlur}
                style={{ width: "100%" }}
                feedback={true}
                promptLabel="Escolha uma senha"
                weakLabel="Senha fraca"
                mediumLabel="Senha média"
                strongLabel="Senha forte"
                footer={PasswordTip}
                placeholder="Informe a senha do usuário"
                tooltip="A senha tem que ser no mínimo média"
                tooltipOptions={{ position: 'bottom', event: 'focus' }}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className="w100 tAlignL formControl">
            <label htmlFor="passwordConfirm">Confirme a senha <span className="requiredField">*</span></label>
              <Password
                inputId="passwordConfirm"
                tabIndex={7} 
                autoComplete="new-password"
                disabled={saving}
                toggleMask
                value={formFields.personUserPasswordConfirm}
                onChange={(e) => handleFieldChange('personUserPasswordConfirm', e.target.value)}
                onBlur={handleBlur}
                style={{ width: "100%" }}
                feedback={false}
                placeholder="Confirme a senha do usuário"
              />
            </div>
          </Grid>

          <Grid item xs={12} sm={12}>
          {!formFields.validatedContact && (
            <div className="formControl tAlignC" style={{ marginTop: '2rem' }}>
              <Button
                label="Validar cadastro"
                tabIndex={8} 
                icon="pi pi-check-circle"
                className="p-button-success"
                onClick={() => setShowValidationDialog(true)}
                disabled={(!formFields.personUserEmail || !formFields.personUserPhone) || (!validarEmail(formFields.personUserEmail) || !validarTelefone(formFields.personUserPhone)) ||
  (formFields.emailInUse || formFields.phoneInUse)}
              />
            
              <small className="fLight dBlock" style={{ marginTop: '0.5rem' }}>
                
                {(!formFields.personUserEmail || !formFields.personUserPhone) || (!validarEmail(formFields.personUserEmail) || !validarTelefone(formFields.personUserPhone)) ||
  (formFields.emailInUse || formFields.phoneInUse) ? 'Informe email e telefone válidos para validar o cadastro.' : 'Você precisa validar seu e-mail e telefone antes de continuar.'}

              </small>
              
            </div>
          )}
          </Grid>

        </Grid>

      </Panel>

      <ValidationCodeDialog
        visible={showValidationDialog}
        onHide={() => setShowValidationDialog(false)}
        email={formFields.personUserEmail}
        phone={formFields.personUserPhone}
        onSuccess={() => {
          handleFieldChange('validatedContact', true);
          updateStepData(stepIndex, { validatedContact: true });
        }}
        setAlert={setAlert}
        setAlertTitle={setAlertTitle}
        setAlertBody={setAlertBody}
      />      

    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  stepData: state.partnerReducer.stepData[ownProps.stepIndex],
  stepDataAll: state.partnerReducer.stepData,
  servicesList: state.partnerReducer.servicesList,
  specialitiesList: state.partnerReducer.specialitiesList,  
});

const mapDispatchToProps = {
  updateStepData,
  ...AppActions
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterStep1);
